import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { defaultRenderLogo } from './index';
export var DefaultContent = function DefaultContent(props) {
  var appList = props.appList,
      baseClassName = props.baseClassName,
      hashId = props.hashId;
  return _jsx("div", {
    className: "".concat(baseClassName, "-content ").concat(hashId),
    children: _jsx("ul", {
      className: "".concat(baseClassName, "-content-list ").concat(hashId),
      children: appList === null || appList === void 0 ? void 0 : appList.map(function (app, index) {
        return _jsx("li", {
          className: "".concat(baseClassName, "-content-list-item ").concat(hashId),
          children: _jsxs("a", {
            href: app.url,
            target: app.target,
            rel: "noreferrer",
            children: [defaultRenderLogo(app.icon), _jsxs("div", {
              children: [_jsx("div", {
                children: app.title
              }), app.desc ? _jsx("span", {
                children: app.desc
              }) : null]
            })]
          })
        }, index);
      })
    })
  });
};